import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { getTenantLocalStorage } from "../../../service/tenant/TenantService";
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import PrincipalLayout from "../menu/PrincipalLayout";
import { Add, FormatListBulleted, Remove } from "@mui/icons-material";
import { searchClientsWithNotifications } from "../../../service/tenant/ClientService";
import ErrorMessageChip from "../util/ErrorMessageChip";
import constants from "../util/Constants";
import { useNavigate } from "react-router";
import SuccessMessageChip from "../util/SuccessMessageChip";
import { notificationTypes } from "../../../service/tenant/StatusService";
import SwitchComponent from "../util/SwitchComponent";
import InputComponent from "../util/InputComponent";
import { convertDateStrToStringUTC } from "../../../service/tenant/ValidationService";
import { useStompClient } from "react-stomp-hooks";
import { getUserData } from "../../../service/tenant/SecurityService";
import { sendClientNotification } from "../../../service/tenant/NotificationsService";
import EditClientContact from "../clients/EditClientContact";


function ClientNotifications(props){
    

    const [activeClients, setActiveClients] = useState([]);
    const [visibleClients, setVisibleClients] = useState([]);
    const [selectedClients, setSelectedClients] = useState([]);
    const [clientMessage, setClientMessage] = useState('');
    const [includeUpdateLink, setIncludeUpdateLink] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [reloadClientNotifications, setReloadClientNotifications] = useState(true);
    const [openClientDialog, setOpenClientDialog] = useState(false);
    const [editClientId, setEditClientId] = useState(null);

    const userData = getUserData();
    const userId = userData.id;
       
        
    const tenant = getTenantLocalStorage();
    const tenantId = tenant.id;

    const stompClient = useStompClient();


    useEffect( () => {

        console.debug('[ClientNotifications] useEffect - handleSearchClientsWithNotifications ');
        handleSearchClientsWithNotifications();
        
    }, [props, reloadClientNotifications]);


    useEffect( () => {

        console.debug('[ClientNotifications] useEffect - handleChangeVisibleClients ');
        handleChangeVisibleClients();
        
    }, [activeClients, rowsPerPage, page]);

    const handleSearchClientsWithNotifications = () => {
        setIsLoading(true);
        searchClientsWithNotifications( notificationTypes.message_to_client.type, tenantId ).then( shortenClientList => {

            if( shortenClientList !== null ){
                setActiveClients(shortenClientList);
            } else {
                setErrorMessage(constants.errors.searchClientError);
            }

            setIsLoading(false);
            
        });
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const handleConfirmSendNotifications = async () => {
        setOpenDeleteAlert(false);
        setIsLoading(true);
        setSuccessMessage('');

        selectedClients.forEach( (client) => {
            sendClientNotification(userId, client, clientMessage, includeUpdateLink, tenantId, stompClient);
        });
        

        let sleepInMillis = selectedClients.length * 500;

        if( sleepInMillis < 5000 ){
            sleepInMillis = 5000;
        }

        sleep(sleepInMillis).then(() => {

            console.debug('[ClientNotifications] handleConfirmSendNotifications waiting ... ');

            setSuccessMessage('Message was sent to clients');
            setIsLoading(false);
            setSelectedClients([]);
            
            setReloadClientNotifications(!reloadClientNotifications);

        });

        
    }

    const handleRefreshClientList = () => {

        console.debug('[ClientNotifications] refreshClientList ... ');

        setSelectedClients([]);
        
        setReloadClientNotifications(!reloadClientNotifications);


    }


    const handleChangeVisibleClients = () => {
        const auxClients = [...activeClients].slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        setVisibleClients(auxClients);
    }

    const handleChangeClientMessage = (attributeName, attributeValue) => {

        setClientMessage(attributeValue);
    }

    const handleChangeIncludeUpdateLink = (attributeName, attributeValue) => {

        if( attributeValue == true ){      
            let defaultClientNotification = constants.messages.defaultClientNotification;
            setClientMessage(defaultClientNotification);
        } else {
            setClientMessage('');
        }

        setIncludeUpdateLink(attributeValue);
    }


    const handleCloseDeleteDialog = () => {
        setOpenDeleteAlert(false);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getLastNotification = ( client ) => {

        if( client.user != null && 
            client.user.notification_list != null &&
            client.user.notification_list.length > 0 ){

            const lastNotification = client.user.notification_list[0];
            return convertDateStrToStringUTC( lastNotification.event_date_time );

        }

    } 

    const handleAddClient = ( client ) => {

        const auxClient = selectedClients.find( o => o.id == client.id  );

        if( auxClient == null ){
            let auxSelectedClients = [...selectedClients];
            auxSelectedClients.push(client);
            setSelectedClients(auxSelectedClients);
        }
        
    }

    const handleRemoveClient = ( index ) => {
        let auxSelectedClients = [...selectedClients];
        auxSelectedClients.splice(index, 1);
        setSelectedClients(auxSelectedClients);
    }

    const validateFormErrors = () => {
        return (
            selectedClients.length > 0 &&
            clientMessage.trim() !== ''
        );
    }

    const handleCloseClientDialog = () => {
        setEditClientId(null);
        setOpenClientDialog(false);
    }

    const handleOpenClientDialog = (clientId) => {
        setEditClientId(clientId);
        setOpenClientDialog(true);
    }


    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - activeClients.length) : 0;

    

    return (
        <PrincipalLayout section={constants.menu.admin_clients_section} isLoading={isLoading} 
                        notificationNumber={props.notificationNumber} 
                        setNotificationNumber={props.setNotificationNumber}
        >

                <Toolbar />

                <Paper sx={constants.styles.paperContainer}>
                    <Grid container direction="row" spacing={0}
                        justifyContent={'left'}
                    >
                        <Grid item sx={constants.styles.sectionTitle} xs={12} md={12}>
                            <Typography 
                                variant="h6"
                                sx={constants.styles.textTitle}
                            >
                                Client notifications&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </Typography>
                            
                        </Grid>
                        
                        
                        <Grid item sx={constants.styles.sectionInput} xs={12} md={12}>
                            &nbsp;
                        </Grid>
                        <Grid sx={constants.styles.sectionError} item xs={12} md={12}>
                            <ErrorMessageChip message={errorMessage} />
                        </Grid>
                        <Grid sx={constants.styles.sectionError} item xs={12} md={12}>
                            <SuccessMessageChip message={successMessage} setMessage={setSuccessMessage} />
                        </Grid>
                        <Grid item xs={12} md={12} sx={constants.styles.sectionTable}>
                            <TableContainer component={Paper} variant="outlined">
                                <Table aria-label="simple table" size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={constants.styles.tableHeader} >Name</TableCell>
                                            <TableCell sx={constants.styles.tableHeader} >Phone</TableCell>
                                            <TableCell sx={constants.styles.tableHeader} >Last notification</TableCell>
                                            <TableCell sx={constants.styles.tableHeader} align="center">Add</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {visibleClients.map((row, index) => (
                                        <TableRow
                                            key={row.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell sx={constants.styles.tableCell} component="th" scope="row">
                                                <Link
                                                    onClick={ () => handleOpenClientDialog(row.id) }
                                                >
                                                    {row.user.first_name + ' ' + row.user.last_name }
                                                </Link>
                                            </TableCell>
                                            <TableCell sx={constants.styles.tableCell}>{row.user.phone}</TableCell>

                                            <TableCell sx={constants.styles.tableCell} align="center">
                                                {
                                                    getLastNotification(row)
                                                }
                                            </TableCell>
                                            
                                            <TableCell sx={constants.styles.tableCell} align="center">
                                                <IconButton 
                                                    size="small" 
                                                    title="Add"
                                                    onClick={ () => handleAddClient(row) }
                                                >
                                                    <Add/>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[10, 20]}
                                component="div"
                                count={activeClients.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />

                        </Grid>


                    

                        <Grid item sx={constants.styles.sectionDivider}  xs={12} md={12}>
                            <Divider/>
                        </Grid>

                        <Grid item sx={constants.styles.sectionTitle} xs={12} md={7} >

                            <Grid container direction="row" spacing={0}
                                justifyContent={'left'}
                                alignContent={'center'}
                                alignItems={'center'}
                            >

                                <InputComponent 
                                    fieldName={"Client message"} 
                                    fieldValue={ clientMessage } 
                                    fieldId={'input-client-message'} 
                                    attributeName={'clientMessage'} 
                                    handleChangeField={handleChangeClientMessage}
                                    required={true} 
                                    multiline={true}
                                    rows={6}

                                    labelSx={12}
                                    labelMd={12}

                                    inputSx={12}
                                    inputMd={12}

                                    sx={constants.styles.textFieldLarge}

                                />

                                <SwitchComponent 
                                    fieldName={"Predefined message"} 
                                    fieldValue={ includeUpdateLink } 
                                    fieldId={'input-include-update-link'} 
                                    attributeName={'includeUpdateLink'} 
                                    handleChangeField={handleChangeIncludeUpdateLink} 
                                    labelSx={4}
                                    labelMd={4}
                                    inputSx={4}
                                    inputMd={4}
                                />

                            </Grid>

                        </Grid>


                        <Grid item sx={constants.styles.sectionTitle} xs={12} md={5} >
                        
                            <Grid container direction="row" spacing={0}
                                justifyContent={'left'}
                                alignContent={'center'}
                                alignItems={'center'}
                                
                            >

                                <Grid item sx={constants.styles.sectionInput} xs={12} md={12}>
                                    <Typography sx={constants.styles.textNormal} >
                                        Selected clients :
                                    </Typography>
                                </Grid>

                                <Grid item 
                                    xs={12} md={12}
                                    sx={constants.styles.sectionTable}
                                >
                                    <TableContainer component={Paper} variant="outlined">
                                        <Table aria-label="simple table" size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={constants.styles.tableHeader} >Name</TableCell>
                                                    <TableCell sx={constants.styles.tableHeader} align="center">Remove</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {selectedClients.map((row, index) => (
                                                <TableRow
                                                    key={row.id}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell sx={constants.styles.tableCell} component="th" scope="row">
                                                        
                                                        {row.user.first_name + ' ' + row.user.last_name }

                                                    </TableCell>
                                                    
                                                    <TableCell sx={constants.styles.tableCell} align="center">
                                                        <IconButton 
                                                            size="small" 
                                                            title="Remove"
                                                            onClick={ () => handleRemoveClient(index) }
                                                        >
                                                            <Remove/>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>

                            </Grid>

                        </Grid>


                        <Grid 
                            container
                            alignItems={'flex-end'}
                            alignContent={'flex-end'}
                            flexDirection={'column'}
                        >

                            <Grid item  
                                xs={12} md={12} 
                                sx={constants.styles.sectionButtons}
                            >
                                <Button 
                                    variant="outlined" 
                                    size="small" 
                                    sx={constants.styles.buttonNormal}
                                    onClick={ () => setOpenDeleteAlert(true) }
                                > 
                                        Send notifications 
                                </Button>

                            </Grid>

                        </Grid>

                    </Grid>
                </Paper>

                <Dialog
                    open={openDeleteAlert}
                    onClose={handleCloseDeleteDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle 
                        id="alert-dialog-title"
                        sx={constants.styles.textNormal}
                    >
                        { validateFormErrors() ?
                            <strong>Do you confirm to send notifications to this clients?</strong>
                            :
                            <strong>There is validation errors, please select at least one client and set a client message</strong>
                        }
                        
                        
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText 
                            id="alert-dialog-description"
                            sx={constants.styles.textNormal}
                        >
                            
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button 
                            variant="outlined" 
                            size="small"
                            sx={constants.styles.buttonNormal}
                            onClick={handleCloseDeleteDialog}
                        >
                            Cancel
                        </Button>
                        { validateFormErrors() ?
                            <Button 
                                variant="outlined" 
                                size="small"
                                sx={constants.styles.buttonNormal}
                                onClick={handleConfirmSendNotifications} 
                                autoFocus>
                                Confirm
                            </Button>
                            :
                            <></>
                        }
                    </DialogActions>
                </Dialog>

                <EditClientContact
                    clientId={ editClientId }
                    openClientDialog={ openClientDialog }
                    handleCloseClientDialog={ handleCloseClientDialog }
                    setIsLoading={setIsLoading}
                    setSuccessMessage={setSuccessMessage}
                    handleRefreshClientList={handleRefreshClientList}
                />
                
        </PrincipalLayout>
    );
}

export default ClientNotifications;